var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"6","cy":"6","r":"6","fill":"#DA4E4E"}}),_c('line',{attrs:{"x1":"3","y1":"6","x2":"9","y2":"6","stroke":"white","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }